/**
 * Mixin xử lý group dữ liệu của grid view/edit
 */

import commonFn from '@/commons/commonFunction.js';
import { shallowReactive } from 'vue';
import _ from 'lodash';
export const gridGroupData = {
  props: {
    // custom lại title của group
    customTitleGroup: {
      default: null,
      type: [Object, Function],
    },
    /**
    //  * Trường để nhóm dữ liệu
     */
    groupField: { default: null, type: Array },
    /**
     * Có hiển thị summary trên dòng group text không
     */ groupSumable: { type: Boolean, default: false },
    /**
     * Dữ liệu sum sẽ lấy từ server
     */ groupSumRemote: { type: Array, default: null },
    /**
     * custom lại cách nhóm dữ liệu
     */ customGroupField: { type: Object, default: {} },
    /**
     * custom lại text nhóm
     */
    buildGroupTextCustom: { type: Function, default: null },
    /**
     * custom lại cách đánh SortOrder
     */
    rebuildSortOrderCustom: { type: Function, default: null },
    /**
     * Thêm sort cho GroupField
     */
    sortTypeGroupField: { type: String, default: 'asc' },
    /**
     * Trường dùng để sắp xếp
     */
    sortValueGroupField: { type: String, default: null },
    /**
     * Hàm custom lại span của cột của dòng group dữ liệu
     * tbngoc 17.01.2022
     */
    customGroupColSpan: { type: Function, default: null },
    /**
     * Trường để xác nhận có sort lại dữ liệu hay không
     * tbngoc 19.01.2022
     */
    isSort: { type: Boolean, default: true },

     /**
     * Đánh dấu có build dòng tổng theo group không
     */
    isSummaryGroup: {type: Boolean, default: false},

    /**
     * Biến kiểm tra xem có đánh lại STT của các bản ghi không
     * NHANH3 06.06.2024
     */
    isCumtomSortOrderGroup: {type: Boolean, default: false},
    /**
     * Hàm sắp xếp lại data group nếu cần
     * NHANH3 06.06.2024
     */
    customSortData: { type: Function, default: null },
  },
  data() {
    return {
      /**
       * Danh sách các group expanded
       */
      groupExpand: [],
    };
  },
  computed: {
    groupData() {
      return this.getDataTree(this.groupField);
    },
    /**
     * Group có rowspan
     * @returns
     */
    groupDataRowSpan() {
      const groupField = this.groupField;
      const datax = this.datax;
      const me = this;
      const seperatorChar = '=+*';

      if (groupField && groupField.length > 0) {
        //Thực hiện group theo từng field 1 để sắp xếp và tính toán rowspan
        const calcRowspan = (data, field, indexField) => {
          const map = new Map();
          data.forEach(function (curRow) {
            //Tính toán key
            const keyRowSpan = `rowspan-${field}`;
            delete curRow[keyRowSpan];
            const key = groupField.reduce((p, c, i) => {
              if (i <= indexField) {
                return p + `${curRow[c] || ''}${seperatorChar}`;
              }
              return p;
            }, '');

            if (map.has(key)) {
              const items = map.get(key);
              const first = items[0];
              first[keyRowSpan] += 1;
              items.push(curRow);
            } else {
              curRow[keyRowSpan] = 1;
              map.set(key, [curRow]);
            }
          });

          return [...map.values()].reduce((pre, cur) => {
            return pre.concat(cur);
          }, []);
        };

        let dataTemp = _.cloneDeep(datax);
        groupField.forEach((field, index) => {
          dataTemp = calcRowspan(dataTemp, field, index);
        });
        return dataTemp;
      }
      return [];
    },
    columnSumary() {
      const columnx = this.columnx && this.columnx.length > 0 ? this.columnx : (this.columns || []);
      let colSums = [{ dataField: 'caption' }];
      let plusCol = 0;

      const me = this;
      //xử lý cột selection và số thứ tự
      if (me.serial) {
        plusCol++;
      }
      if (me.multiple) {
        plusCol++;
      }
      columnx.forEach((column, index) => {
        if ((column.summaryType && column.summaryType != me.$ms.constant.SummaryType.RowCount) || colSums.length > 1) {
          const colSumary = Object.assign({}, column);
          colSums.push(colSumary);
          if (!colSums[0].groupColspan) {
            colSums[0].groupColspan = index + plusCol;
          }
        }
      });

      if (
        colSums.length == 1 &&
        !columnx.find(x => x.summaryType && x.summaryType != me.$ms.constant.SummaryType.RowCount)
      ) {
        if (!colSums[0].groupColspan) {
          colSums[0].groupColspan = columnx.length;
        }
      }

      if (this.customGroupColSpan && typeof this.customGroupColSpan === 'function') {
        colSums = this.customGroupColSpan(colSums, columnx);
      }

      return colSums;
    },
  },
  methods: {
    /**
     * Sau khi sort group cần gán lại số thứ tự
     */
    rebuildSortOrder(res) {
      let me = this;
      if (typeof me.rebuildSortOrderCustom === 'function') {
        me.rebuildSortOrderCustom(res);
      } else {
        let currentPage = (me.currentPage - 1) * me.pageSize + 1;
        res.flatMap(x => x.datax).map((x, idx) => (x.SortOrder = currentPage + idx));
      }
    },
    /**
     * Xử lý summary của group
     * xử lý cho các trường kiểu số
     */
    processGroupSummary(groups) {
      const me = this;
      if (!me.groupSumable) {
        groups.forEach(item => {
          item.colspan = me.columnx.length + 1; // cộng 1 để colspan thêm cột stt
        });
      } else {
        //xử lý lấy các cột sẽ sum
        let cols = [];
        let firstIndexSumColumn = null;
        let columnLockNumber = 0; // tổng số cột bị ghim
        me.columnx.forEach((col, i) => {
          if (col.lock) {
            columnLockNumber++;
          }

          if (col.summaryType) {
            if (!firstIndexSumColumn) {
              firstIndexSumColumn = i;
            }
            cols.push({
              index: i,
              dataField: col.dataField,
              formatType: col.formatType,
              summaryType: col.summaryType,
              align: col.align,
            });
          }

          // switch (col.formatType) {
          //   case me.$ms.constant.FormatType.Amount:
          //   case me.$ms.constant.FormatType.QuantityConvert:
          //   case me.$ms.constant.FormatType.Quantity:
          //   case me.$ms.constant.FormatType.Number:
          //     if (col.dataField != "Sortorder") {
          //       if (!firstIndexSumColumn) {
          //         firstIndexSumColumn = i;
          //       }
          //       cols.push({
          //         index: i,
          //         dataField: col.dataField,
          //         formatType: col.formatType,
          //         summaryType: col.summaryType,
          //       });
          //     }
          //     break;
          // }
        });

        //nếu không có cột sum nào -> colspan all
        if (cols.length === 0) {
          groups.forEach(item => {
            item.colspan = me.columnx.length;
          });
        } else {
          //xử lý tính sum cho từng group
          groups.forEach(group => {
            let sum = {};

            if (me.groupSumRemote && me.groupSumRemote.length > 0) {
              for (let i = 0; i < me.groupSumRemote.length; i++) {
                let gs = me.groupSumRemote[i];
                if (gs[me.groupField] === group.value) {
                  sum = gs;
                  break;
                }
              }
            } else {
              // me.getSumValue(col)
              cols.forEach(col => {
                if (col.summaryType) {
                  sum[col.dataField] = me.getSumValue(col.summaryType, group.datax, col.dataField);
                }
              });
            }

            let colspan = 1;
            if (columnLockNumber > 0) {
              colspan = Math.min(columnLockNumber, firstIndexSumColumn);
            } else {
              colspan = firstIndexSumColumn;
            }

            //column
            group.columnx = [];
            if (colspan < cols[0].index) {
              group.columnx.push({
                colspan: cols[0].index - colspan,
                empty: true,
              });
            }

            for (let i = cols[0].index; i < me.columnx.length; i++) {
              let map = null;
              for (let j = 0; j < cols.length; j++) {
                if (cols[j].index === i) {
                  map = cols[j];
                  break;
                }
              }

              if (map) {
                group.columnx.push({
                  formatType: map.formatType,
                  value: sum[map.dataField],
                  field: map.dataField,
                  align: map.align,
                });
              } else {
                group.columnx.push(null);
              }
            }

            //xử lý cột selection và số thứ tự
            if (me.serial) {
              colspan++;
            }
            if (me.multiple) {
              colspan++;
            }

            if (colspan > 1) {
              group.colspan = colspan;
            }
          });
        }
      }
    },
    /**
     * Xử lý summary cho group
     * @param {*} op : toán tử ~ summaryType (hoặc xem xét tách groupSumType)
     * @param {*} data : dữ liệu gốc
     * @param {*} field: trường thông tin
     */

    getSumValue(op, data, field) {
      const me = this;
      let res = null;
      switch (op) {
        case me.$ms.constant.SummaryType.Sum:
          res = 0;
          for (let i = 0; i < data.length; i++) {
            let value = data[i][field];
            if (typeof value === 'undefined' || value == null) {
              continue;
            }

            res += value;
          }
          break;
        case me.$ms.constant.SummaryType.Min:
          for (let i = 0; i < data.length; i++) {
            let value = data[i][field];
            if (typeof value === 'undefined' || value == null) {
              continue;
            }

            if (res == null) {
              res = value;
            } else if (value < res) {
              res = value;
            }
          }
          break;
        case me.$ms.constant.SummaryType.Max:
          for (let i = 0; i < data.length; i++) {
            let value = data[i][field];
            if (typeof value === 'undefined' || value == null) {
              continue;
            }

            if (res == null) {
              res = value;
            } else if (value > res) {
              res = value;
            }
          }
          break;
        case me.$ms.constant.SummaryType.Avg:
          res = 0;
          for (let i = 0; i < data.length; i++) {
            let value = data[i][field];
            if (typeof value === 'undefined' || value == null) {
              continue;
            }

            res += value;
          }

          res = res / data.length;
          break;
      }

      return res;
    },
    /**
     * build text hiển thị của column
     */

    buildGroupText(group, index, column) {
      const me = this;
      let text = me.$ms.format.formatData(group.value, {
        formatType: column ? column.formatType : 0,
        enumName: column ? column.enum : null,
      });

      // return text;
      let resultText = [index + 1, '. ', text == '-' ? 'Khác' : text, ' (', group.datax.length, ')'].join('');

      if (typeof me.buildGroupTextCustom === 'function') {
        try {
          resultText = me.buildGroupTextCustom(group, index, column, text, resultText);
        } catch (ex) {
          console.errror(ex);
        }
      }

      return resultText;
    },
    /**
     * collapse/expand group
     */
    toggleGroup(group) {
      const me = this,
        value = group.value;
      if (me.groupExpand.indexOf(value) === -1) {
        me.groupExpand.push(value);
      } else {
        me.groupExpand.remove(value);
      }
    },
    /**
     * expand all group data
     */
    expandAll() {
      const me = this;
      if (me.groupData) {
        let gs = [];
        me.groupData.forEach(item => {
          gs.push(item.value);
        });
        me.groupExpand = gs;
      }
    },
    /**
     * expand dữ liệu mặc định sau khi render
     * expand nhóm đầu - để hiệu năng render tốt nhất
     */
    defaultExpand() {
      const me = this;
      me.expandAll();
      return;

      if (me.groupData) {
        let gs = [];
        if (me.groupData.length > 0) {
          gs.push(me.groupData[0].value);
        }
        me.groupExpand = gs;
      }
    },
    /**
     * collapse all group data
     */

    collapseAll() {
      const me = this;
      me.groupExpand = [];
    },
    /**
     * gender date tree cho group
     * @param {*} newVal
     * @param {*} customTitleGroupFn: Function custom lại title của group
     * NXCHIEN 24.10.2022
     * Modified: HMDUC2: 02/05/2024: Build thêm dòng tổng theo group tương ứng
     */
    getDataTree(newVal) {
      const me = this;
      const groupFieldNewVal = newVal;
      let datax = this.editor ? this.dataView : this.datax;
      const sortValueGroupField = me.sortValueGroupField ? me.sortValueGroupField.split(',') : [];

      const columnx = this.columnx && this.columnx.length > 0 ? _.cloneDeep(this.columnx) : _.cloneDeep(this.columns);
      if (me.isSort) {
        datax = datax.sortObject(...groupFieldNewVal, ...sortValueGroupField);
      }
      
      // Custom sắp xếp lại data
      if (me.customSortData && typeof me.customSortData == 'function') {
        me.customSortData(datax);
      }

      const seperatorChar = '=+*';
      const map = {};
      if (groupFieldNewVal && groupFieldNewVal.length > 0 && columnx?.length > 0) {
        const length = groupFieldNewVal.length;
        const summaryCols = columnx.filter(x => x.summaryType && x.summaryType != me.$ms.constant.SummaryType.RowCount);

        //Cộng tổng
        //TODO=> Có thể thêm các loại summary khác, xử lý sau
        const plusSummary = (rowParent, row) => {
          summaryCols.forEach(x => {
            if (!rowParent[x.dataField]) {
              rowParent[x.dataField] = 0;
            }
            rowParent[x.dataField] += row[x.dataField];
          });
        };

        const columnMap = {};
        columnx.forEach(x => (columnMap[x.dataField] = x));

        groupFieldNewVal.forEach((field, index, arr) => {
          datax.forEach(function (curRow, iRow) {
            // Lấy ra column của cột cần group
            let col = columnx.find(x => x.dataField == field);

            curRow.indexRow = iRow;
            //Tính toán key
            const key = arr.reduce((p, c, i) => {
              if (i <= index) {
                let colKey = columnx.find(x => x.dataField == c);
                let valueFormatKey = colKey
                  ? me.$ms.format.formatData(curRow[c], {
                      formatType: colKey.formatType,
                      optionFormat: colKey.optionFormat,
                      enumName: colKey.enum,
                    }) || ''
                  : curRow[c];

                return p + `${valueFormatKey}${seperatorChar}`;
              }
              return p;
            }, '');

            let valueFormat = col
              ? me.$ms.format.formatData(curRow[field], {
                  formatType: col.formatType,
                  optionFormat: col.optionFormat,
                  enumName: col.enum,
                }) || ''
              : curRow[field];
            //Nếu có cấu hình link thì bổ sung thẻ span
            if (me.linkedGroupField && me.linkedGroupField === field) {
              valueFormat = commonFn.removeScriptTags(`<span class="text-link">${valueFormat}</span>`);
            }

            const rowGroup = shallowReactive({
              groupLevel: index + 1,
              isGroup: true,
              caption:
                me.customTitleGroup?.[field]?.[curRow[field]] ??
                `${columnMap[field]?.caption || me.customGroupField[field]}: ${valueFormat}`,
              [me.idField]: commonFn.generateUUID(),
              expanded: true,
            });

            //Cộng sum lên theo từng dòng
            summaryCols.forEach(x => {
              rowGroup[x.dataField] = curRow[x.dataField];
            });

            if (!map[key]) {
              map[key] = rowGroup; // create a copy of o

              const parentKey = key.replace(
                `${
                  col
                    ? me.$ms.format.formatData(curRow[field], {
                        formatType: col.formatType,
                        optionFormat: col.optionFormat,
                        enumName: col.enum,
                      }) || ''
                    : curRow[field]
                }${seperatorChar}`,
                ''
              );

              //Thực hiện push các node vào parent đã có nếu k phải root
              if (parentKey) {
                if (Array.isArray(map[parentKey]?.childNodes)) {
                  map[parentKey].childNodes.push(map[key]);
                } else if (map[parentKey]) {
                  map[parentKey].childNodes = [map[key]];
                }
              }
            } else {
              plusSummary(map[key], curRow);
            }

            //Nếu là item field cuối cùng thì thực hiện thêm node list là row vào data
            if (index === length - 1) {
              if (map[key].childNodes) {
                map[key].childNodes.push(curRow);
              } else {
                map[key].childNodes = [curRow];
              }
            }
          });
        });

        const objVals = Object.values(map);
        const rootLevel = 1;
        const roots = objVals.filter(x => x.groupLevel === rootLevel);
        const expanded = true,
          isGroup = true,
          fieldChild = 'childNodes';
        const dataTree = commonFn.getBodyData(roots, expanded, rootLevel, fieldChild, isGroup, me.customTitleGroup);

        //HMDUC2: Push thêm dòng tổng cho group.
        if(dataTree.length > 0 && me.isSummaryGroup){
          // tìm vị trí để push dòng tổng
          // do dòng group đang ở đầu nên sẽ tìm từ index 0 -> đến index = length childnode của group 
          //  thì thêm dòng tổng vào vị trí index + 1
          dataTree.map((item, index) => {
            // tìm dòng group
            if(item?.isGroup && item?.caption !== me.$t('i18nComponent.Grid.GroupSum')){
              // Item tổng của gr 
              var sumGroup = {
                caption: me.$t('i18nComponent.Grid.GroupSum'),
                groupLevel: 1,
                level: 1,
                isGroup: true,
                isSummaryGr: true,
              };

              // Lấy các cột có tỉnh tổng theo summaryCols
              var fieldSummaryCols = [];
              if(summaryCols?.length > 0){
                fieldSummaryCols = summaryCols.map(x => x.dataField);
              };
              // Lấy giá trị của cột tổng đã được tính thêm vào obj summGroup
              fieldSummaryCols.forEach((col , index) => {
                 var value = item[col];
                 sumGroup[col] = value;

                 // Ẩn giá trị tổng ở dòng group đầu đi do đã hiển thị ở cột tổng group
                 item[col] = undefined;
              });           

              // vị trí push dòng tổng của gr
              var indexPushSumGr = 0;

              if(item.childNodes && item.childNodes.length > 0){
                // Nếu có group có child node thì vị tí dòng tổng gr = index gr cha + số lượng child node + 1  (do index từ 0)
                indexPushSumGr = index + item?.childNodes?.length + 1  
              }else{
                // Nếu group không có child node thì vị trí dòng tổng gr = index gr cha + 1(do sau gr luôn có 1 dòng) + 1 (do index từ 0)
                indexPushSumGr = index + 1 + 1;  
              }
              // push dòng tổng group sau dòng con cuối cùng của gr
              dataTree.splice(indexPushSumGr,0,sumGroup);
            }

          })
        }

        // Custom lại sort_order (NHANH3 06.06.2024)
        if (me.isCumtomSortOrderGroup) {
          me.rebuildSortOrder(dataTree);
        }
        return dataTree;
      }
      return [];
    },
    /**
     * render lại group khi groupField thay đổi
     * @param {*} newVal
     * @param {*} oldVal
     * NXCHIEN 24.10.2022
     */
    buildGroupGrid(newVal, oldVal) {
      const me = this;
      if (!oldVal || newVal) {
        let dataTree = this.getDataTree(newVal);
        me.groupDataView = dataTree;
      } else {
        me.gridGroupData = _.cloneDeep(me.datax);
      }
    },
  },
};
